import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { ErrorMessage } from '@hookform/error-message';
import Errors from '../common/Errors';
import { DividedRow, Full, Half } from '../common/RowLengths';
import Accordion from '../common/Accordion';
import slugify from '../../helpers/slugify';
import {
  handleCreateContainer,
  defaultValues,
} from './constants/handleContainer';
import Icon from '../common/Icon';

const NewContainer = ({ updateContainerIndex }) => {
  const [showNewContainer, setShowNewContainer] = useState(false);
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    watch,
    setValue,
    getFieldState,
    reset,
    setError,
    formState: { errors },
  } = useForm({
    criteriaMode: 'all',
    defaultValues,
  });

  useEffect(() => {
    if (
      document.activeElement.name == 'name' &&
      getFieldState('name').isDirty
    ) {
      setValue('slug', slugify(watch('name')), { shouldDirty: true });
    }
  }, [watch('name')]);

  const toggleShowNewContainer = (e) => {
    e.preventDefault();
    if (showNewContainer) {
      document.activeElement.blur();
      reset();
    }
    setShowNewContainer(!showNewContainer);
  };

  const onSubmit = async (formData) => {
    let newContainer = await handleCreateContainer(formData);
    if (newContainer.ok) {
      updateContainerIndex(newContainer.data);
      setShowNewContainer(false);
      reset(defaultValues);
      navigate(`/manage/containers/${newContainer.data.id}`);
    } else if (newContainer.errors) {
      Object.entries(newContainer.errors).forEach(([key, message]) =>
        setError(key, { types: { [key]: message } })
      );
    }
  };

  return (
    <Accordion
      id='new-container-dropdown'
      expanded={showNewContainer}
      toggle={toggleShowNewContainer}
    >
      <form onSubmit={handleSubmit(onSubmit)} id='new-container-form'>
        <fieldset>
          <DividedRow>
            <Full title='Display Name:'>
              <input
                placeholder='2016 SayWhat! Summits'
                {...register('display_name')}
              />
            </Full>
          </DividedRow>

          <DividedRow>
            <Half title='Name:'>
              <input
                placeholder='SayWhat! Summits'
                {...register('name', {
                  // required: 'Required',
                  deps: 'slug',
                })}
              />
              <ErrorMessage
                errors={errors}
                name='name'
                render={({ messages }) => <Errors messages={messages} />}
              />
            </Half>

            <Half title='Slug:'>
              <input
                placeholder='registration'
                {...register('slug', {
                  required: 'Required',
                  onBlur: (e) => setValue('slug', slugify(e.target.value)),
                })}
              />
              <ErrorMessage
                errors={errors}
                name='slug'
                render={({ messages }) => <Errors messages={messages} />}
              />
            </Half>
          </DividedRow>
        </fieldset>

        <div className='controls'>
          <button type='submit'>
            Save
            <Icon icon='save' />
          </button>
          <button className='blue' onClick={toggleShowNewContainer}>
            Cancel
            <Icon icon='xmark' />
          </button>
        </div>
      </form>
    </Accordion>
  );
};

export default NewContainer;
